export interface TrainingModule {
  _id: string;
  title: string;
  description: string;
  category: string;
  companyCode?: string;
  categoryCode?: string;
  sequenceNumber?: number;
  thumbnailBlobPath?: string;
  estimatedMinutes?: number;
  order: number;
  isPublished: boolean;
}

export function moduleCode(m: TrainingModule): string {
  if (!m.companyCode || !m.categoryCode || m.sequenceNumber == null) return '';
  return `${m.companyCode}-${m.categoryCode}-${String(m.sequenceNumber).padStart(3, '0')}`;
}

export interface TrainingContent {
  _id: string;
  moduleId: string;
  sectionId?: string;
  title: string;
  type: 'image' | 'pdf' | 'video';
  order: number;
  caption?: string;
  mimeType?: string;
  originalFileName?: string;
}

export interface TrainingSection {
  _id: string;
  moduleId: string;
  title: string;
  type: 'slideshow' | 'image' | 'video';
  order: number;
  items: TrainingContent[];
}

export interface TrainingProgress {
  contentCompletedAt: string | null;
  passed: boolean;
  latestScore: number | null;
  lastAttemptedAt: string | null;
}

export interface TrainingModuleListItem {
  module: TrainingModule;
  progress: TrainingProgress | null;
}

export interface TrainingModuleDetail {
  module: TrainingModule;
  sections: TrainingSection[];
  progress: TrainingProgress | null;
}

export interface TrainingQuizOption {
  _id: string;
  text: string;
}

export interface TrainingQuizQuestion {
  _id: string;
  type: 'multiple_choice' | 'true_false' | 'multi_select' | 'free_text';
  prompt: string;
  options: TrainingQuizOption[];
  order: number;
}

export interface TrainingQuiz {
  moduleId: string;
  passingScore: number;
  questions: TrainingQuizQuestion[];
}

export interface QuizAnswer {
  questionId: string;
  selectedOptions: number[];
  freeText: string;
}

export interface QuizAnswerResult {
  questionId: string;
  correct: boolean | null;
  requiresReview: boolean;
}

export interface QuizResult {
  score: number;
  passed: boolean;
  passingScore: number;
  answers: QuizAnswerResult[];
}

export interface ApiResponse<T> {
  data: T;
}

// Admin interfaces — include isCorrect for quiz editing

export interface TrainingQuizOptionAdmin {
  _id?: string;
  text: string;
  isCorrect: boolean;
}

export interface TrainingQuizQuestionAdmin {
  _id?: string;
  type: 'multiple_choice' | 'true_false' | 'multi_select' | 'free_text';
  prompt: string;
  options: TrainingQuizOptionAdmin[];
  order: number;
}

export interface TrainingQuizAdmin {
  moduleId?: string;
  passingScore: number;
  questions: TrainingQuizQuestionAdmin[];
}

export interface UploadTokenResponse {
  uploadUrl: string;
  blobPath: string;
  expiresAt: string;
}
